<template>
    <div class="float-left mr-1">
        <span class="text-primary">
            <i
                v-if="evento.statusId != 2 && acao.codSituacao != 1"
                class="fa fa-edit fa-lg icon-button"
                title="Atualizar Evento"
                @click.stop="abrirModal()"
            ></i>
        </span>
        <evento-form
            operacao="A"
            :evento="evento"
            :acao="acao"
            :mostrarModal="mostrarModal"
            :erros="erros"
            @fechar="fecharModal()"
            @salvar="salvar($event)"
        ></evento-form>
    </div>
</template>

<script>
import EventoForm from './EventoForm'
import EventosServicos from './EventosServicos'

export default {
    components: {
        EventoForm
    },

    props: {
        evento: {
            type: Object,
            default: () => {}
        },

        acao: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            mostrarModal: false,
            erros: []
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
        },

        salvar(evento) {
            this.$store.dispatch('addRequest')
            let eventoDto = {
                nomeEvento: evento.nomeEvento,
                codEvento: evento.codEvento,
                idEvento: evento.idEvento,
                idAcaoPlanoTrabalho: evento.idAcaoPlanoTrabalho
            }
            EventosServicos.alterarEvento(eventoDto).then((response) => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Evento atualizado com sucesso',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$emit('atualizarLista')
                        this.fecharModal()
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },
}
</script>
